import React from 'react';
import PropTypes from 'prop-types';

export default function BylineNames({ authors }) {
  return (
    <span className="PrismicBylineNames">
      {authors.map((author, idx) => {
        let join;

        if (idx === authors.length - 1 && authors.length > 2) {
          join = ', and ';
        } else if (idx !== 0 && idx === authors.length - 1) {
          join = ' and ';
        } else if (idx !== 0) {
          join = ', ';
        }

        return (
          <span key={idx}>
            {join}
            {author.full_name}
          </span>
        );
      })}
    </span>
  );
}

BylineNames.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string
    })
  ).isRequired
};
